<template>

    <div class="main-body position-relative  border-box">
      <vue-custom-scrollbar class="full-width full-height">
      <div class="nav-title ">
          <div class="flex flex-center-cz margin-left-xl font-xl font-bold flex-space-between full-width">
              <div class="pointer" style="width: 100px;">最近浏览</div>
              <SearchInput :val="filter"  :placeholder="'请输入文档名或内容查询'" style="width: 300px;" @search="search"></SearchInput>
              <div class="border-box" style="width: 100px;"></div>
          </div>
      </div>
      <div class="file-pnl border-box" style="margin-top:45px">
            <div v-for="(item,index) in fileData" style="width: 25%;" class="flex flex-center-sp" :key="index">
              <div class="file-box boder-box" >
                <div class="pointer dir-box border-box"  @click="gridItemClick(item.docData.id)"  >
                  <img v-if="item.docData.cover && item.docData.cover != ''" class="file-img" :src="item.docData.cover"/>
                  <div v-if="!item.docData.cover|| item.docData.cover == ''" class="file-img padding-s font-s ">{{item.docData.summary}}</div>
                </div>
                <div class="file-desc">
                  <div class="file-left">
                    <div class="file-name text-more row1 full-width">{{item.docData.name}}</div>
                    <div class="flex flex-row file-remark">
                      <div class="margin-right-l flex flex-row" style="width:40px"><img class="dianzan-ico" src="@/assets/images/dianzan.png"/><div class="margin-left-m ">{{item.docData.likeCount}}</div></div>
                      <div class="margin-right-l flex flex-row" style="width:45px"><img class="chakan-ico" src="@/assets/images/chakan.png"/><div class="margin-left-m ">{{item.docData.viewCount}}</div></div>
                      <div class="margin-right-l flex flex-row" style="width:45px"><img class="pinglun-ico" src="@/assets/images/pinglun.png"/><div class="margin-left-m ">{{item.docData.commentCount}}</div></div>
                      <div class="margin-right-l flex flex-row" style="width:45px"><img class="shoucang-ico" src="@/assets/images/shoucang.png"/><div class="margin-left-m ">{{item.docData.collectCount}}</div></div>
                    </div>
                  </div>
                  <div class="file-right">
                    <div class="file-share pointer" @click="share(item.docData)"><img class="share-img" src="@/assets/images/share.png"/></div>
                  </div>
                </div>  
              </div>
                      
            </div>
      </div> 
      
      <div v-if="fileData != null && fileData.length == 0" style="margin-top: 50px;width: 95%;" class="flex flex-col flex-center-cz">
          <img style="width: 250px;height: 250px;" src="@/assets/images/empty-data.png"/>
          <div class="font-l">空空如也</div>
      </div>

      <Share :data="shareData" :show="showShare" @close="showShare = false"></Share>
    </vue-custom-scrollbar>
    </div>     
    
    </template>
    
    <script>
      /*
            名称：浏览历史
            功能：
            作者：唐赢   
            时间：2022-11-30
      */
    
      import {viewList} from '@/api/api.js';
      import Mixin from '@/mixin/mixin';
      import MixinDoc from '@/mixin/mixinDoc';
      import Share from '@/modules/share/Share.vue'
      import SearchInput from '@/components/searchInput/SearchInput.vue'


      export default {
        name: 'Main',
        mixins:[Mixin,MixinDoc],
        components: {
            Share,SearchInput
        },
        data () {
          return {
            filter:"",
            fileData: null,
            showShare: false,
            shareData:{},
    
          }
        },

        created() {

        },
        mounted() {
          if (sessionStorage.getItem("history_filter") && sessionStorage.getItem("history_filter")  != "") {
            this.filter = sessionStorage.getItem("history_filter")
          } else {
            this.filter = ""
          }
          this.list();

        },        
        methods: {
            search(value) {
              this.filter = value;
              sessionStorage.setItem("history_filter", value)
              this.list();
            },
            list() {
              this.$showLoading();
              if (!this.filter) {
                this.filter = ""
              }
              viewList(this.filter).then((res) => {
                console.log(res);
                this.$closeLoading();
                let fileData = res.data.result.filter(d=>d.docData != null);
                
                this.fileData = fileData;
              })
            },
            gridItemClick(id) {
                this.$router.push({
                  path: '/doc',
                  query: {
                    id: id
                  }
              })
            },  
            stopPropa(event) {
                event || (event = window.event);
                event.stopPropagation ? event.stopPropagation(): (event.cancelBubble = true);
                document.addEventListener("click", this.closeClick, false);// 监听关闭事件
            },
    
            closeClick(e) {
                console.log("销毁监听事件。");
                document.removeEventListener("click", this.closeClick, false);
                this.showOpMenu = false;
            },

          
        }
      }
    </script>
    
      <!-- Add "scoped" attribute to limit CSS to this component only -->
    <style scoped>
    
        .file-right{
            width: 35px;
        }

        .dir-box {
            overflow: hidden;
            height: 170px;
        }
  
    
    </style>
      


// WEBPACK FOOTER //
// src/views/History.vue